import React, { useState, useCallback, useEffect } from 'react';
import {
    Form, Modal, Input, message, Select, Tabs
} from 'antd';

import CONSTANT from '../../../config/constant';
import * as Service from '../../../config/service'

const status = [
    { value: 'published', label: 'Công khai' },
    { value: 'draft', label: 'Bản nháp' },
];

const ModalAction = (props) => {
    const actionTitle = props?.data ? "Sửa loại cơ sở y tế" : "Thêm loại cơ sở y tế";
    const [form] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);

    // Hủy
    const handleCancel = useCallback(() => {
        form.resetFields();
        props.cancel();
        setConfirmLoading(false);
    }, [form]);

    // Load thong tin cho form
    const loadForm = () => {
        form.setFieldsValue({
            name: props.data?.name || '',
            description: props.data?.description || '',
            name_en: props.data?.translations?.en.name || '',
            description_en: props.data?.translations?.en.description || '',
            status: props.data?.is_active === true ? 'published' : 'draft'
        });
    }

    // Xử lý lưu
    const onSubmit = useCallback(async (values) => {
        setConfirmLoading(true);
        values.is_active = values.status === 'published' ? true : false;
        values.translations = {
            en: {
                name: values.name_en,
                description: values.description_en
            }
        }
        // Nếu thêm mới
        if (!props.data?._id) {
            await Service.post(`${CONSTANT.API.HOSPITAL.TYPE}`, values)
                .then(res => {
                    if (res && res.data && res.data.code === 200) {
                        message.success('Lưu thông tin thành công!', 1);
                    }
                    else {
                        message.error('Lưu thông tin thất bại! Vui lòng thử lại sau.');
                    }
                }).catch(err => {
                    message.error('Lưu thông tin thất bại! Vui lòng thử lại sau.')
                });
        }
        else {
            await Service.patch(`${CONSTANT.API.HOSPITAL.TYPE}/${props.data._id}`, values)
                .then(res => {
                    if (res && res.data && res.data.code === 200) {
                        message.success('Lưu thông tin thành công!', 1);
                    }
                    else {
                        message.error('Lưu thông tin thất bại! Vui lòng thử lại sau.');
                    }
                }).catch(err => {
                    message.error('Lưu thông tin thất bại! Vui lòng thử lại sau.');
                });
        }

        setTimeout(() => {
            setConfirmLoading(false);
            // đóng modal
            handleCancel();
            // load lai danh sách
            props.reload()
        }, 2000);
    }, [props]);

    useEffect(() => {
        loadForm();
    }, [props.data]);


    return (
        <Modal title={actionTitle}
            visible={props.isModalVisible}
            onOk={form.submit}
            onCancel={handleCancel}
            confirmLoading={confirmLoading}
            cancelText="Hủy"
            okText="Lưu thông tin"
            forceRender
            destroyOnClose={true}
        >
            <Form
                name="basic"
                layout="vertical"
                onFinish={onSubmit}
                onFinishFailed={() => { }}
                form={form}
                initialValues={{
                    status: "draft"
                }}
            >
                <Tabs defaultActiveKey="vi" type="card" size="large">
                    <Tabs.TabPane tab="Tiếng Việt" key="vi" forceRender={true}>
                        <Form.Item
                            label="Tên" name="name"
                            required tooltip="Trường bắt buộc nhập"
                            rules={[
                                { required: true, message: 'Vui lòng nhập tên!' },
                            ]}
                        >
                            <Input placeholder="Tên" />
                        </Form.Item>
                        <Form.Item
                            label="Mô tả ngắn gọn" name="description"
                        >
                            <Input.TextArea placeholder="Nhập mô tả ngắn gọn" />
                        </Form.Item>
                    </Tabs.TabPane>
                    <Tabs.TabPane forceRender={true} tab="Tiếng Anh" key="en">
                        <Form.Item
                            label="Tên" name="name_en"
                            required tooltip="Trường bắt buộc nhập"
                            rules={[
                                { required: true, message: 'Vui lòng nhập tên!' },
                            ]}
                        >
                            <Input placeholder="Tên" />
                        </Form.Item>
                        <Form.Item
                            label="Mô tả ngắn gọn" name="description_en"
                        >
                            <Input.TextArea placeholder="Nhập mô tả ngắn gọn" />
                        </Form.Item>
                    </Tabs.TabPane>
                </Tabs>
                <Form.Item
                    label="Trạng thái"
                    name="status"
                >
                    <Select
                        placeholder="Chọn trạng thái"
                        style={{ width: '100%' }}
                    >
                        {
                            status.map(item => <Select.Option key={item.value}>{item.label}</Select.Option>)
                        }
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    )
}
export default ModalAction;